/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import S7Image from 'yoda-core-components/lib/components/S7Image/S7Image';
import { findMobileOS } from 'yoda-core-components/lib/helpers/Utils/Utils';
import classNames from 'classnames/bind';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Play from 'yoda-core-components/lib/assets/svg/White_Play_Icon.svg';
import SlickCarousel from 'yoda-site-components/lib/components/SlickCarousel/SlickCarousel';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import VideoPlayer from 'yoda-site-components/lib/components/VideoPlayer/VideoPlayer';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { getImageSrc } from 'yoda-core-components/lib/helpers/AssetUtils';
import { getScene7Config } from 'yoda-core-components/lib/helpers/AssetUtils/builders/assetConfig';
import SlickCarouselLarge from '../SlickCarouselLarge/SlickCarouselLarge';
import VideoContainer from '../VideoContainer/VideoContainer';
import UrgencyMessagingConnected from '../UrgencyMessaging/UrgencyMessaging';
import formattedFilmStripData from '../../helpers/FormatImagesAndVideos';
import * as styles from './ProductImageCarousel.css';
import SlickCarouselWrapper from '../SlickCarouselNew/SlickCarousalWrapper';

const cx = classNames.bind(styles);

const carouselTheme = {
    carouselSelected: cx(styles.selected),
    carouselBullets: cx(styles.carouselBullets),
    bullet: styles.bullet,
    slideClass: styles.carouselSlide,
    slickTrackClass: styles.slickTrackClass,
    bulletContainer: styles.bulletContainer,
};

export default class ProductImageCarousel extends Component {
    static propTypes = {
        productImagesAndVideos: PropTypes.oneOfType([PropTypes.array]),
        onImageClick: PropTypes.func,
        deviceType: PropTypes.oneOfType([PropTypes.object]),
        slideCallback: PropTypes.func,
        triggerAnalytics: PropTypes.func,
        dataAutomationId: PropTypes.string,
        displayTapOnZoom: PropTypes.bool,
        isBundle: PropTypes.bool,
        selectedIndex: PropTypes.number,
        isCarouselTabDisplay: PropTypes.bool,
        urgencyMessagingEnabled: PropTypes.bool,
        enableVideoPlacementChange: PropTypes.bool,
        ppId: PropTypes.string,
        enableZoomOnProductImage: PropTypes.bool,
        isMobilePDPImageZoomed: PropTypes.bool,
        isOrientationLandscapeForZoom: PropTypes.bool,
        isMarketPlaceProduct: PropTypes.bool,
        enableMarketPlace: PropTypes.bool,
        enableSiteCoreVideo: PropTypes.bool,
    };

    static defaultProps = {
        productImagesAndVideos: [],
        onImageClick: null,
        slideCallback: null,
        triggerAnalytics: null,
        dataAutomationId: null,
        deviceType: {},
        displayTapOnZoom: false,
        isBundle: false,
        selectedIndex: 0,
        isCarouselTabDisplay: true,
        urgencyMessagingEnabled: true,
        enableVideoPlacementChange: false,
        ppId: null,
        enableZoomOnProductImage: false,
        isMobilePDPImageZoomed: false,
        isOrientationLandscapeForZoom: false,
        isMarketPlaceProduct: false,
        enableMarketPlace: false,
        enableSiteCoreVideo: false,
    };

    // eslint-disable-next-line react/state-in-constructor
    state = {
        enableZoomToolTip: false,
    };

    componentDidMount() {
        const {
            deviceType: { isTablet },
            isMobilePDPImageZoomed,
        } = this.props;
        this.setState({
            // eslint-disable-line react/no-did-mount-set-state
            enableZoomToolTip: !!this.props.displayTapOnZoom,
            isIPad: findMobileOS() === 'iOS' && isTablet,
        });
        const timeoutval = isMobilePDPImageZoomed ? 100 : 4000;
        setTimeout(this.setState.bind(this, { enableZoomToolTip: false }), timeoutval);
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { isOrientationLandscapeForZoom } = this.props;
        if (nextProps.productImagesAndVideos !== this.props.productImagesAndVideos) {
            return true;
        }

        if (nextProps.isOrientationLandscapeForZoom !== isOrientationLandscapeForZoom) {
            return true;
        }

        if (nextState.enableZoomToolTip !== this.state.enableZoomToolTip) {
            return true;
        }

        return false;
    }

    productImageListRenderer = (dataItem, idx) => {
        const {
            deviceType,
            enableVideoPlacementChange,
            selectedIndex,
            isMarketPlaceProduct,
            enableMarketPlace,
            enableSiteCoreVideo,
        } = this.props;
        /* istanbul ignore next */
        if (!deviceType.isDesktop && dataItem.isVideo) {
            if (
                dataItem.type === 'Scene7' ||
                (enableMarketPlace && isMarketPlaceProduct) ||
                enableSiteCoreVideo
            ) {
                return this.renderScene7Video(dataItem, idx);
            }
            return (
                <div className={cx('unplayable-video')}>
                    <VideoContainer url={dataItem.url} />
                </div>
            );
        }
        if (deviceType.isDesktop && dataItem.isVideo) {
            return enableVideoPlacementChange ? (
                <div
                    className={`${cx(
                        'image-desktop',
                        'overlay',
                        idx === selectedIndex && 'overlaySelected'
                    )}`}
                >
                    <div
                        className={cx(
                            idx !== selectedIndex && 'thumbnailImg',
                            idx === selectedIndex && 'selectedBlock'
                        )}
                    >
                        {this.renderVideoThumbnail(dataItem, idx)}
                    </div>
                    <div className={cx('videoIconPlayButton')}>
                        <Icon
                            iconType="svg"
                            pathClassName={cx('iconPath')}
                            className={`${cx('svg-icon')}`}
                            width="28"
                            height="32.15"
                            viewBox="0 0 20 20"
                        >
                            <Play />
                        </Icon>
                    </div>
                </div>
            ) : (
                <div className={cx('videoIcon')}>
                    <span className={cx('playIcon', 'playButton')} />
                </div>
            );
        }

        return this.renderImage(dataItem, idx);
    };

    carouselSwitch() {
        let renderCarousel = '';
        const {
            productImagesAndVideos,
            slideCallback,
            dataAutomationId,
            deviceType,
            isCarouselTabDisplay,
            urgencyMessagingEnabled,
            enableVideoPlacementChange,
            enableZoomOnProductImage,
            ppId,
            isMobilePDPImageZoomed,
            // eslint-disable-next-line react/prop-types
            preferences: { videoPlacementPosition = 3 } = {},
            isBundle,
            isOrientationLandscapeForZoom,
            isMarketPlaceProduct,
            enableMarketPlace,
        } = this.props;
        const key = 'productImageCarouselWrapper';
        // new zoom changes wont be applied for bundle in initial phase
        let isExecuteOldLayout = !(enableZoomOnProductImage && !isBundle);
        if (isOrientationLandscapeForZoom) {
            isExecuteOldLayout = true;
        }
        if (isExecuteOldLayout) {
            if (deviceType.isDesktop) {
                renderCarousel = (
                    <ErrorBoundary>
                        <SlickCarouselLarge
                            carouselData={
                                enableVideoPlacementChange
                                    ? formattedFilmStripData(
                                          videoPlacementPosition,
                                          productImagesAndVideos
                                      )
                                    : productImagesAndVideos
                            }
                            carouselItemRenderer={this.productImageListRenderer}
                            themeConfig={carouselTheme}
                            automationId={dataAutomationId}
                            slideCallback={slideCallback}
                            rewindOnChange
                            key={key}
                            swipeOptions={{ continuous: false }}
                            deviceType={deviceType}
                            isMarketPlaceProduct={isMarketPlaceProduct}
                            enableMarketPlace={enableMarketPlace}
                        />
                    </ErrorBoundary>
                );
            } else {
                renderCarousel = (
                    <ErrorBoundary>
                        <SlickCarousel
                            isCarouselTabDisplay={isCarouselTabDisplay}
                            carouselData={
                                enableVideoPlacementChange
                                    ? formattedFilmStripData(
                                          videoPlacementPosition,
                                          productImagesAndVideos
                                      )
                                    : productImagesAndVideos
                            }
                            carouselItemRenderer={this.productImageListRenderer}
                            themeConfig={carouselTheme}
                            automationId={dataAutomationId}
                            slideCallback={slideCallback}
                            rewindOnChange
                            autoSize
                            lazyLoad
                            displayArrows={deviceType.isTablet}
                            repeat={false}
                            key={key}
                            isPDPImage
                            enableVideoPlacementChange={enableVideoPlacementChange}
                            ppId={ppId}
                        />
                        {urgencyMessagingEnabled ? (
                            <span
                                data-automation-id="urgency-icon"
                                className={`${cx('UrgencyMessaging')} ${dt([
                                    'absolute',
                                    '-translate-x-1/2',
                                    'left-1/2',
                                    'w-full',
                                ])}`}
                            >
                                <UrgencyMessagingConnected />
                            </span>
                        ) : null}
                    </ErrorBoundary>
                );
            }
        } else {
            renderCarousel = (
                <div>
                    <SlickCarouselWrapper
                        productImagesAndVideos={productImagesAndVideos}
                        slideCallback={slideCallback}
                        automationId={dataAutomationId}
                        deviceType={deviceType}
                        isCarouselTabDisplay={isCarouselTabDisplay}
                        enableVideoPlacementChange={enableVideoPlacementChange}
                        ppId={ppId}
                        preferences={{ videoPlacementPosition: 3 }}
                        rewindOnChange
                        carouselTheme={carouselTheme}
                        carouselItemRenderer={this.productImageListRenderer}
                        enableZoomOnProductImage={enableZoomOnProductImage}
                        isMobilePDPImageZoomed={isMobilePDPImageZoomed}
                        isPDPImage
                        isMarketPlaceProduct={isMarketPlaceProduct}
                        enableMarketPlace={enableMarketPlace}
                        enableSiteCoreVideo={this.props.enableSiteCoreVideo}
                    />
                </div>
            );
        }
        return renderCarousel;
    }

    renderImage(dataItem, idx) {
        const {
            dataAutomationId,
            deviceType,
            enableZoomOnProductImage,
            onImageClick,
            isBundle,
            isOrientationLandscapeForZoom,
        } = this.props;
        let image;
        // new zoom changes wont be applied for bundle in initial phase
        let isExecuteOldLayout = !(enableZoomOnProductImage && !isBundle);
        if (isOrientationLandscapeForZoom) {
            isExecuteOldLayout = true;
        }

        if (deviceType.isDesktop) {
            image = (
                <div className={cx('image-desktop')}>
                    <S7Image
                        src={dataItem.rawUrl || dataItem.url}
                        alt={dataItem.altText}
                        automationId={`${dataAutomationId}-s7image-${idx}`}
                        context={dataItem.context || 'filmstrip'}
                        sourceType={dataItem.sourceType}
                        slickImage
                    />
                </div>
            );
        } else {
            isExecuteOldLayout
                ? (image = (
                      <div className={cx({ bundleImageContainer: isBundle })}>
                          <a id="image-zoom" href="javascript:void;" onClick={onImageClick}>
                              <ErrorBoundary>
                                  <S7Image
                                      src={dataItem.rawUrl || dataItem.url}
                                      alt={dataItem.altText}
                                      automationId={`${dataAutomationId}-s7image-${idx}`}
                                      context={dataItem.context || 'pdp'}
                                      sourceType={dataItem.sourceType}
                                  />
                              </ErrorBoundary>
                          </a>
                      </div>
                  ))
                : (image = (
                      <div className={cx({ bundleImageContainer: isBundle })}>
                          <ErrorBoundary>
                              <S7Image
                                  src={dataItem.rawUrl || dataItem.url}
                                  alt={dataItem.altText}
                                  automationId={`${dataAutomationId}-s7image-${idx}`}
                                  context={dataItem.context || 'pdp'}
                                  sourceType={dataItem.sourceType}
                              />
                          </ErrorBoundary>
                      </div>
                  ));
        }
        return image;
    }

    /* istanbul ignore next */
    renderScene7Video(dataItem, idx) {
        const {
            dataAutomationId,
            isMarketPlaceProduct,
            enableMarketPlace,
            enableSiteCoreVideo,
            triggerAnalytics,
            deviceType,
            selectedIndex,
        } = this.props;
        const { isIPad } = this.state;
        const isNonScene7Video = dataItem.type !== 'Scene7';
        const imageContainer = !__SERVER__ && document.querySelector('#product-image-wrapper');
        const querySlide =
            !__SERVER__ && imageContainer && imageContainer.querySelector('.slick-slide');
        const style = {
            height:
                isIPad &&
                !isNonScene7Video &&
                querySlide &&
                querySlide.getBoundingClientRect().height,
        };

        return (
            <div className={cx('scene7-video-container')} style={style}>
                <VideoPlayer
                    url={dataItem.url}
                    pageId={`pdpVideo-${idx}`}
                    playerProps={{ url: isNonScene7Video ? dataItem.url : dataItem.id }}
                    automationId={`${dataAutomationId}-video-${idx}`}
                    triggerAnalytics={triggerAnalytics}
                    disableAutoPlay
                    deviceType={deviceType}
                    selectedIndex={selectedIndex}
                    isPDP
                    isMarketplaceVideo={
                        enableMarketPlace && isMarketPlaceProduct && isNonScene7Video
                    }
                />
            </div>
        );
    }

    /* istanbul ignore next */
    renderVideoThumbnail = (dataItem, idx) => {
        const isExternalVideo = dataItem.url && !dataItem.url.includes('scene7.com');

        if (isExternalVideo) {
            return (
                <video
                    src={dataItem.url}
                    className="video-thumbnail"
                    style={{
                        width: '99px',
                        height: '99px',
                        objectFit: 'cover',
                        borderRadius: '0.5rem',
                    }}
                    preload="auto"
                    muted
                    onLoadedData={(e) => {
                        e.target.currentTime = 2;
                    }}
                    data-automation-id={`mirakl-video-thumbnail-${idx}`}
                />
            );
        }

        // Use Scene7 thumbnail for Scene7 videos
        const { imageThumbnailBase } = getScene7Config();
        return (
            <S7Image
                src={getImageSrc(
                    `${imageThumbnailBase}${dataItem.id}`,
                    {},
                    { context: 'filmstrip' }
                )}
                alt={dataItem.altText}
                automationId={`s7image-${idx}`}
                extensionRequired
                slickImage
            />
        );
    };

    renderZoomTooltip = () => (
        <div
            className={cx('zoom-tooltip', { 'zoom-tooltip--hide': !this.state.enableZoomToolTip })}
        >
            Tap to zoom
        </div>
    );

    render() {
        const { productImagesAndVideos, displayTapOnZoom, isMobilePDPImageZoomed } = this.props;
        let displayzoomicon = displayTapOnZoom;
        /* istanbul ignore next */
        if (displayTapOnZoom && isMobilePDPImageZoomed) {
            displayzoomicon = false;
        }
        return (
            <div className={cx('carousel-wrapper')} id="product-image-wrapper">
                {productImagesAndVideos &&
                    productImagesAndVideos.length > 0 &&
                    this.carouselSwitch()}
                {displayzoomicon && this.renderZoomTooltip()}
            </div>
        );
    }
}
